import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    additionalSelector: {
      display: 'grid',
      gridTemplateColumns: `1fr auto`,
      gridColumnGap: theme.spacing(1),
    },
    tableHeaderRow: {
      backgroundColor: 'rgb(211,211,211,0.3)',
    },
    header: {
      color: '#05A4D8',
      fontSize: '15px',
      fontWeight: 'bold',
    },
    error: {
      color: 'red',
      fontSize: '13px',
      fontWeight: 'bold',
      textAlign: 'left',
    },
  };
};
